import createGetFormAsyncErrors from './selectors/getFormAsyncErrors';
import plain from './structure/plain';

export default createGetFormAsyncErrors(plain);


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/es/getFormAsyncErrors.js
// module id = 2220
// module chunks = 1